import React from 'react';
import PropTypes from 'prop-types';
import MCTopView from '@learningblocks/exp-constants/lib/Images/microcentrifuge_topview_lid_closed.svg';
import {Image} from '@learningblocks/storybook-components';

import './style.scss';

export function LidClosed(props) {
  return (
    <div className='mc_equipment_topview--closed'>
      <Image
        className='mc_equipment_topview--closed_image'
        src={MCTopView}
        alt='microcentrifuge top view lid closed'
      />
      <div
        className='mc_equipment_topview--closed_lid'
        onClick={props.toggleLid}></div>
    </div>
  );
}

LidClosed.propTypes = {
  /**
   * callback for when lid is clicked
   */
  toggleLid: PropTypes.func,
};
